import { Reducer } from 'redux'
import { ActionTypes, DEPOSIT_INSTRUCTIONS_ACTIONS } from './types'
import { BANK_TRANSFER_NETWORK } from '~/types'

const initialState = {
  isFastLiveBannerEnabled: false,
  selectedTabNetwork: BANK_TRANSFER_NETWORK.FAST,
}

type State = {
  isFastLiveBannerEnabled: boolean
  selectedTabNetwork: BANK_TRANSFER_NETWORK
}

export const depositInstructions: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case DEPOSIT_INSTRUCTIONS_ACTIONS.SET_IS_FAST_LIVE_BANNER_ENABLED: {
      return {
        ...state,
        isFastLiveBannerEnabled: action.isFastLiveBannerEnabled,
      }
    }

    case DEPOSIT_INSTRUCTIONS_ACTIONS.SET_SELECTED_TAB_NETWORK: {
      return {
        ...state,
        selectedTabNetwork: action.selectedTabNetwork,
      }
    }

    default:
      return state
  }
}
